/* eslint-disable max-len */
// angular modules
import { ScrollingModule } from '@angular/cdk/scrolling';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MultilevelMenuService, NgMaterialMultilevelMenuModule } from 'ng-material-multilevel-menu'; // multilevel menu
import { HIGHLIGHT_OPTIONS, HighlightModule } from 'ngx-highlightjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';


// shared modules
import { AppRoutingModule } from './app-routing.module';

// NGRX Store Modules
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'src/environments/environment';
import { StoreEffects } from './store/effects';
import { metaReducers, reducers } from './store/reducers';

// components
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { HomeComponent } from './shared/components/home/home.component';
import { ProfileComponent } from './shared/components/profile/profile.component';

// feature modules
import { CommonModules } from './common/common.module';
import { ExternalUserModule } from './external-user/external-user.module';
import { InternalUserModule } from './internal-user/internal-user.module';
import { SharedModule } from './shared/shared.module';

// Directives
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DragDropDirective } from './shared/directives/dragdrop.directive';
import { NoHtmlTagsDirective } from './shared/directives/NoHtmlTags.directive';
import { TrimDirective } from './shared/directives/trim.directive';
import { BrowserModule } from '@angular/platform-browser';
import { EulaDialogComponent } from './shared/components/eula-dialog/eula-dialog.component';
import { AccountDeactivatedNotifyDialogComponent } from './shared/components/account-deactivated-notify-dialog/account-deactivated-notify-dialog.component';
import { UserManagementDialogComponent } from './shared/components/user-management-dialog/user-management-dialog.component';
import { AddOrganizationDialogComponent } from './internal-user/customer-management/components/add-organization/add-organization-dialog.component';
import { AddSiteDialogComponent } from './internal-user/customer-management/components/add-site/add-site-dialog.component';
import { IncadaTenantSelectComponent } from './internal-user/customer-management/components/incada-tenant-select/incada-tenant-select.component';
import { IncadaLocationSelectComponent } from './internal-user/customer-management/components/incada-location-select/incada-location-select.component';
import { EditOrganizationDialogComponent } from './internal-user/customer-management/components/edit-organization-dialog/edit-organization-dialog.component';
import { AuthInterceptor } from './auth/auth.interceptor';
import { ListItemContentComponent } from './shared/ng-material-multilevel-menu/list-item/list-item-content/list-item-content.component';
import { SharedService } from './shared/services/shared.service';

import { MatSidenavModule } from '@angular/material/sidenav';
import { PermissionGroupsDialogComponent } from './shared/components/permission-groups-dialog/permission-groups-dialog.component';
import { IdleTimeMonitorService } from './shared/idle-time-monitor/idle-time-monitor.service';

import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { EditSiteDialogComponent } from './internal-user/customer-management/components/edit-site-dialog/edit-site-dialog.component';
import { IncadaInformationComponent } from './internal-user/customer-management/components/incada-information.component';

@NgModule({ declarations: [
        AppComponent,
        HomeComponent,
        ProfileComponent,
        HeaderComponent,
        DragDropDirective,
        NoHtmlTagsDirective,
        TrimDirective,
        EulaDialogComponent,
        AccountDeactivatedNotifyDialogComponent,
        UserManagementDialogComponent,
        PermissionGroupsDialogComponent,
        AddOrganizationDialogComponent,
        AddSiteDialogComponent,
        IncadaTenantSelectComponent,
        IncadaLocationSelectComponent,
        EditOrganizationDialogComponent,
        ListItemContentComponent,
        EditSiteDialogComponent,
        IncadaInformationComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
    bootstrap: [AppComponent], imports: [FormsModule,
        BrowserAnimationsModule,
        BrowserModule,
        NgMaterialMultilevelMenuModule,
        ReactiveFormsModule,
        HighlightModule,
        FontAwesomeModule,
        ScrollingModule,
        AppRoutingModule,
        SharedModule,
        InternalUserModule,
        ExternalUserModule,
        CommonModules,
        StoreModule.forRoot(reducers, { metaReducers }),
        EffectsModule.forRoot(StoreEffects),
        StoreDevtoolsModule.instrument({
            maxAge: 25, // Retains last 25 states
            logOnly: environment.production, // Restrict extension to log-only mode
            connectInZone: true
        }),
        MatButtonToggleModule,
        MatSidenavModule], providers: [
        IdleTimeMonitorService,
        MultilevelMenuService,
        SharedService,
        NgxUiLoaderService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: HIGHLIGHT_OPTIONS,
            useValue: {
                coreLibraryLoader: () => import('highlight.js/lib/core'),
                languages: {
                    json: () => import('highlight.js/lib/languages/json'),
                }
            }
        },
        {
            // MDC migration: apply global subscript sizing setting to form fields to preserve old behavior
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { subscriptSizing: 'dynamic' }
        },
        {
            provide: MAT_SELECT_CONFIG,
            useValue: { panelWidth: 'auto' } 
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
